<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-credit-card`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.095 6h39.81C45.062 6 46 6.895 46 8v32c0 1.105-.938 2-2.095 2H4.095C2.938 42 2 41.105 2 40V8c0-1.105.938-2 2.095-2zM6 10v6h36v-6H6zm0 28V20h36v18H6zm5-8a1 1 0 00-1 1v2a1 1 0 001 1h10a1 1 0 001-1v-2a1 1 0 00-1-1H11z"/></svg>
</template>
<script>

export default {
  name: 'IconCreditCard',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
